module.exports = __webpack_public_path__ + "static/interactiveFallback@2x-fe6f8b382b429b4a13f711ba26fafaf1.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/why-marvel/interactiveFallback@2x.png
// module id = 2721
// module chunks = 168707334958949